import { isEmpty } from 'ramda';
import { branch, renderNothing } from 'recompose';
import BenefitBox from './BenefitBox';

export default branch(
  ({ benefits }) => isEmpty(benefits),
  renderNothing,
)(BenefitBox);
